import { MINUTE } from '@/core/constants/constants'

import { createApiMethod, type } from './utils/createApiMethod'

export type BatchOperation =
  | 'user_import'
  | 'user_edit'
  | 'user_deactivate'
  | 'user_reactivate'
  | 'user_group_assignment'
  | 'department_assignment'

export type BatchOperationsSort = 'filename' | 'status' | 'uploaded_at'

export type BatchOperationStatus =
  | 'pending'
  | 'failed'
  | 'parsing'
  | 'parsed'
  | 'processing'
  | 'completed'

export type BatchOperationFile = {
  filename: string
  id: string
  num_failed_entries: number
  num_success_entries: number
  num_total_entries: number
  operation: BatchOperation
  status: BatchOperationStatus
  upload_date: string
  uploaded_by: string
}

export type BatchOperationsQuery = {
  page?: number
  size?: number
  sort_by?: BatchOperationsSort
  sort_order?: 'asc' | 'desc'
  filename?: string
  operation?: BatchOperation
  creator_id?: string
  status?: BatchOperationStatus[]
  from_uploaded_at?: string
  to_uploaded_at?: string
}

export type BatchOperationsResponse = {
  batch_operation_files: BatchOperationFile[]
  total_files: number
}

export const batchOperations = {
  list: createApiMethod({
    method: 'GET',
    path: '/batch-operations/',
    query: type<BatchOperationsQuery>(),
    response: type<BatchOperationsResponse>(),
    config: { paramsSerializer: { indexes: null } },
  }),

  file: {
    errors: {
      list: createApiMethod({
        method: 'GET',
        path: '/batch-operations/:batchOperationFileId/errors',
        response: type<Blob>(),
        config: { responseType: 'blob' },
      }),
    },
  },
}

export const batchOperationsQueries = {
  all: () => ['batch-operations'] as const,
  lists: () => ({
    queryKey: [...batchOperationsQueries.all(), 'lists'] as const,
  }),
  list: (query: BatchOperationsQuery) => ({
    queryKey: [...batchOperationsQueries.lists().queryKey, query] as const,
    queryFn: () => batchOperations.list({ query }),
    staleTime: MINUTE * 5,
  }),
}
